import React from "react";
import * as styles from "./punchCard.styles";
import styled, { css } from "react-emotion";
import { priceToDollars } from "helpers";
import WebIcon from "../../WebIcon";

const StyledPunchCard = styled("div")`
  color: black;
  width: 100%;
  box-sizing: content-box;
  border-radius: 5px;
  text-align: center;
  margin: ${(props) => (props.margin ? props.margin : "5 0 5 0")};
  background: ${(props) => (props.background ? props.background : "white")};
  border: ${(props) => "1px solid " + props.color};
  padding: 10px 0px;
  margin: 10px;
`;

const StarsContainer = styled("div")`
  width: 50%;
`;

const finePrintStyle = css`
  font-size: 12px;
  word-wrap: break-word;
  color: black;
  margin: 10px;
`;

const descriptionStyle = css`
  color: black;
`;

const Punchcard = (props) => {
  const {
    id,
    title,
    numberOfUses,
    retired,
    finePrint,
    margin,
    description,
    border,
    barColor,
    maxDiscount,
    numberOfStampsUserHas,
    isAnonUser,
  } = props;

  const generateStamps = () => {
    if (numberOfUses < 1) return null;

    const imgProps = {
      src:
        "https://mobile360-assets.s3.us-east-2.amazonaws.com/filled_star.svg",
      style: {
        width: "25px",
      },
    };

    const starPerRow = () => {
      if (numberOfUses % 6 === 0 || numberOfUses % 6 === 5) {
        return (10 / 6) * 10;
      } else {
        return (10 / 5) * 10;
      }
    };

    if (numberOfStampsUserHas === null || numberOfStampsUserHas === 0)
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <StarsContainer>
            <styles.StarGroup>
              {[...Array(numberOfUses)].map((el) => {
                return (
                  <div
                    key={el}
                    style={{
                      // width: `${starPerRow()}%`,
                      width: "20%",
                      marginBottom: "20px",
                    }}
                  >
                    {/* <img {...imgProps} /> */}
                    <WebIcon
                      iconName={"unfilledStar"}
                      useColor={true}
                      size={"30px"}
                    />
                  </div>
                );
              })}
            </styles.StarGroup>
          </StarsContainer>
        </div>
      );
    else {
      const numberOfStampsRemaining = numberOfUses - numberOfStampsUserHas;
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <StarsContainer>
            <styles.StarGroup>
              {[...Array(numberOfStampsUserHas)].map((el) => {
                return (
                  <div
                    key={el}
                    style={{
                      // width: `${starPerRow()}%`,
                      width: "20%",
                      marginBottom: "20px",
                    }}
                  >
                    {/* <img {...imgProps} /> */}
                    <WebIcon
                      iconName={"filledStar"}
                      useColor={true}
                      size={"30px"}
                    />
                  </div>
                );
              })}
              {[...Array(numberOfStampsRemaining)].map((el) => {
                return (
                  <div
                    key={el}
                    style={{
                      // width: `${starPerRow()}%`,
                      width: "20%",
                      marginBottom: "20px",
                    }}
                  >
                    {/* <img {...imgProps} /> */}
                    <WebIcon
                      iconName={"unfilledStar"}
                      useColor={true}
                      size={"30px"}
                    />
                  </div>
                );
              })}
            </styles.StarGroup>
          </StarsContainer>
        </div>
      );
    }
  };
  return (
    <StyledPunchCard
      border={border}
      margin={margin}
      background={retired ? "grey" : null}
      color={barColor}
    >
      <h2 style={{ color: "black", margin: "10px" }}>{title}</h2>

      {description ? (
        <p className={descriptionStyle}>{description}</p>
      ) : (
        <p className={descriptionStyle}></p>
      )}
      {generateStamps()}
      {maxDiscount ? (
        <p className={descriptionStyle} style={{ fontSize: "14px" }}>
          Max Discount: {priceToDollars(maxDiscount)}
        </p>
      ) : (
        <p className={descriptionStyle}></p>
      )}
      {/* <RedeemButton color={barColor}>Get A Stamp!</RedeemButton> */}

      {finePrint ? (
        <p className={finePrintStyle}>Fine Print: {finePrint}</p>
      ) : (
        <p className={finePrintStyle}></p>
      )}
    </StyledPunchCard>
  );
};

export default Punchcard;
